import { Box, Flex, Text } from "@chakra-ui/react"
import { LuDownload, LuExternalLink, LuX } from "react-icons/lu"
import { FaApple, FaMicrosoft, FaYahoo } from "react-icons/fa"
import { FcGoogle } from "react-icons/fc"
import { BORDER_COLOR, META_COLOR, SUBTLE_BG, TITLE_COLOR } from "./constants"
import { downloadIcs, googleCalendarUrl, outlookCalendarUrl, yahooCalendarUrl } from "./calendarLinks"

// Bottom sheet that slides up over the chat panel so the user can pick a
// calendar without leaving the chat. `event` carries the session info shown in
// the sheet plus the datetimes the links are built from.
export default function AddToCalendarDrawer({ event, onClose }) {
    const options = [
        {
            label: "Google Calendar",
            Brand: FcGoogle,
            Icon: LuExternalLink,
            run: () => window.open(googleCalendarUrl(event), "_blank", "noopener"),
        },
        {
            label: "Apple Calendar",
            Brand: FaApple,
            brandColor: "#1E293B",
            Icon: LuDownload,
            run: () => downloadIcs(event),
        },
        {
            label: "Outlook",
            Brand: FaMicrosoft,
            brandColor: "#0078D4",
            Icon: LuDownload,
            run: () => downloadIcs(event),
        },
        {
            label: "Outlook.com",
            Brand: FaMicrosoft,
            brandColor: "#0078D4",
            Icon: LuExternalLink,
            run: () => window.open(outlookCalendarUrl(event), "_blank", "noopener"),
        },
        {
            label: "Yahoo Calendar",
            Brand: FaYahoo,
            brandColor: "#5F01D1",
            Icon: LuExternalLink,
            run: () => window.open(yahooCalendarUrl(event), "_blank", "noopener"),
        },
    ]

    return (
        <Box position="absolute" inset={0} zIndex={10}>
            <Box position="absolute" inset={0} bg="rgba(15,23,42,0.45)" onClick={onClose} />
            <Box
                position="absolute"
                bottom={0}
                left={0}
                right={0}
                bg="#fff"
                borderTopRadius="16px"
                boxShadow="0 -8px 30px rgba(15,25,60,0.2)"
                px="20px"
                pt="16px"
                pb="24px"
                style={{ animation: "drawerSlideUp 0.25s ease" }}
            >
                <style>{`
                    @keyframes drawerSlideUp {
                        from { transform: translateY(100%); }
                        to { transform: translateY(0); }
                    }
                `}</style>
                <Flex align="center" justify="space-between" mb="12px">
                    <Text fontSize="16px" fontWeight="600" color={TITLE_COLOR} mt={0}>
                        Add to Calendar
                    </Text>
                    <Flex
                        align="center"
                        justify="center"
                        w="28px"
                        h="28px"
                        cursor="pointer"
                        borderRadius="6px"
                        onClick={onClose}
                        title="Close"
                        _hover={{ bg: "rgba(0,0,0,0.06)" }}
                    >
                        <LuX color={TITLE_COLOR} size={18} />
                    </Flex>
                </Flex>

                <Box bg={SUBTLE_BG} borderRadius="8px" px="12px" py="10px" mb="14px">
                    {event.kindLabel && (
                        <Text
                            fontSize="9px"
                            fontWeight="700"
                            letterSpacing="0.06em"
                            textTransform="uppercase"
                            color={META_COLOR}
                            mt={0}
                        >
                            {event.kindLabel}
                        </Text>
                    )}
                    <Text fontSize="15px" fontWeight="600" color={TITLE_COLOR} lineHeight={1.3} mt={0}>
                        {event.title}
                    </Text>
                    {event.meta && (
                        <Text fontSize="13px" color={META_COLOR} mt="2px">
                            {event.meta}
                        </Text>
                    )}
                </Box>

                <Flex direction="column" gap="8px">
                    {options.map(({ label, Brand, brandColor, Icon, run }) => (
                        <Flex
                            key={label}
                            align="center"
                            justify="space-between"
                            px="14px"
                            py="10px"
                            borderRadius="8px"
                            border="1px solid"
                            borderColor={BORDER_COLOR}
                            cursor="pointer"
                            onClick={() => {
                                run()
                                onClose()
                            }}
                            _hover={{ bg: SUBTLE_BG }}
                        >
                            <Flex align="center" gap="10px">
                                <Brand color={brandColor} size={16} />
                                <Text fontSize="13px" fontWeight="500" color={TITLE_COLOR} mt={0}>
                                    {label}
                                </Text>
                            </Flex>
                            <Icon color={META_COLOR} size={14} />
                        </Flex>
                    ))}
                </Flex>
            </Box>
        </Box>
    )
}
